import React from "react";
import './contact.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import emailjs from "emailjs-com"
import { useEffect } from 'react';
import { useRef, useState } from "react";

const Contact  = () =>{
  const formRef = useRef();
    const [done, setDone] = useState(false)
  const handleSubmit = (e) =>{e.preventDefault();
     emailjs
      .sendForm(
        "service_nznwrgq",
        "template_2edfao9",
        formRef.current,
        "user_4PbCsuDnDNFVvqz1tdoXC"
      )
     .then(
        (result) => {
          console.log(result.text);
          setDone(true)
        },

        (error) => {
          console.log(error.text);
        }
      );
  };


  useEffect(()=>{Aos.init({
      duration: 2000,
     });
   },[]);


    return(
        <div className="contact" id="contact" data-aos= 'fade-right'>
          <h3>Send me  a message!</h3>
        <p>Got a question or proposal, or just want
        to say hello? Go ahead.</p>
        <form ref={formRef} onSubmit={handleSubmit} className="contact__form">
           <input type='text' placeholder="Name" name="user_name" />
           <input type='text' placeholder="Subject" name="user_subject" />     
         <input type='text' placeholder="Email" name="user_email" />

         <div className="contact__info">
            <button type="submit">Send</button>  
         </div>
         {done && "Thank you..."}
          </form>
        </div>
    );
}


export default React.memo(Contact);